import * as yup from 'yup'

export const addYearSchema = yup.object({
	name: yup.string().required(),
})
